import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiResponse, getBaseQuery } from "../CustomFetch";

export const api = createApi({
  reducerPath: "api",
  baseQuery: getBaseQuery(),
  endpoints: () => ({}),
});

export function transformApiResponse<DataType>(apiResponse: ApiResponse<DataType>): DataType {
  return apiResponse.data;
}
